import '../App.css';
import { useState, useEffect } from 'react';
import { URL_LINKDIN, URL_EMAIL, URL_GITHUB } from '../config.js';
import { useTitleCardPos } from '../TitleCards';

function Contact() {

  const { contact } = useTitleCardPos();
  const [slide, setSlide] = useState(false);
          
  useEffect(() => {
  const onScroll = () => {
      const scroll = window.scrollY;
      if (scroll > 2400) {
          setSlide(true);
      }
  }

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
    }, []);

  
  return (
    <div>
      <div ref={contact} className='title-container'>
                <div className='title'>
                    Get in <span style={{ color: '#598fcb' }}>Touch</span>
                </div>
            </div>
      <div className={'contact-container'} style={{ opacity: slide ? '100%' : '0%' }}>
        <div className='contact-grid'>
          <div onClick={() => {redirectToExternalUrl(URL_EMAIL)}} className='contact-card'>
            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-mail-icon lucide-mail"><path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"/><rect x="2" y="4" width="20" height="16" rx="2"/></svg>    
            <p>Email:</p>
            <div className='contact'>william.harvey1083@gmail.com</div>
          </div>
          <div onClick={() => {redirectToExternalUrl(URL_GITHUB)}} className='contact-card'>
            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-github-icon lucide-github"><path d="M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4"/><path d="M9 18c-4.51 2-5-2-7-2"/></svg>                                
            <p>Github:</p>
            <div className='contact'>Bill1083</div>
          </div>
          <div onClick={() => {redirectToExternalUrl(URL_LINKDIN)}} className='contact-card'>
            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-linkedin-icon lucide-linkedin"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect width="4" height="12" x="2" y="9"/><circle cx="4" cy="4" r="2"/></svg>
            <p>LinkedIn:</p>
            <div className='contact'>William Harvey</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;

export function redirectToExternalUrl (url) {
  window.location.href = url;
};